import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import whiteLogo from "../assets/images/WH-Logo.png";
import moment from "moment";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <footer className="footer-section text-center py-4">
        <div className="container">
          {/* <h3 className="mb-3">Best Alert</h3> */}
          <img src={whiteLogo} alt="logo" className="footer-logo" />
          <div className="social-icons-footer justify-content-center mb-3">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              className="social-icon"
            >
              <i className="fa fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/accounts/login/?hl=en"
              target="_blank"
              className="social-icon"
            >
              <i className="fa fa-instagram"></i>
            </a>
            <a href="https://x.com/" target="_blank" className="social-icon">
              <i className="fa fa-twitter"></i>
            </a>
            <a
              href="https://www.youtube.com/"
              target="_blank"
              className="social-icon"
            >
              <i className="fa fa-youtube"></i>
            </a>
          </div>
          <div className="footer-bottom  align-items-center">
            <span className="copyright-text">
              {t(
                "©Copyright {{year}} Offary. All rights reserved."
              ).replace("{{year}}", moment().format("YYYY"))}{" "}
            </span>
            <span className="terms-text">
              <Link to="/t&c">{t("Terms & Conditions")}</Link> |{" "}
              <Link to="/privacy-policy">{t("Privacy Policy")}</Link>
            </span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
